import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

import { PayLoadValue } from '@cashier/cashier-model';

interface AmountValueContextPayload {
  value: string | null;
  setValue: (value: string) => void;
}

const defaultAmountValueContextPayload: AmountValueContextPayload = {
  value: '',
  setValue: (_: string) => {
    throw new Error(
      'setValue function must be used within a AmountValueProvider',
    );
  },
};

const AmountValueContext = createContext<AmountValueContextPayload>(
  defaultAmountValueContextPayload,
);

interface AmountValueProviderProps {
  initialValue: PayLoadValue;
  children: ReactNode;
}

export const AmountValueProvider = ({
  initialValue,
  children,
}: AmountValueProviderProps) => {
  const [amount, setAmount] = useState<string | null>(
    initialValue === null ? null : (initialValue as string),
  );

  const amountValueProviderValue = useMemo(
    () => ({ value: amount, setValue: setAmount }),
    [amount, setAmount],
  );

  return (
    <AmountValueContext.Provider value={amountValueProviderValue}>
      {children}
    </AmountValueContext.Provider>
  );
};

export const useAmountValueContext = () => useContext(AmountValueContext);
